// A task field is unusable (and should read that way, not just look empty) until a dag
// is chosen and its tasks have finished loading.
export const getTaskFieldPlaceholder = (
  selectedDag: string,
  isFetchingTasks: boolean,
  readyPlaceholder: string
): string => {
  if (!selectedDag) return 'Select a dag first';
  if (isFetchingTasks) return 'Loading tasks...';
  return readyPlaceholder;
};
